import { makeAutoObservable } from 'mobx';
import { DATA } from './data';
import { addMinutes } from 'date-fns';

export type RewardType = 'speed' | 'price' | 'money' | null;

export const REWARD_DURATION_MINUTES = 2;
export const INITIAL_INTERVAL_MINUTES = 1;
export const SUBSEQUENT_INTERVAL_MINUTES = 1.5 + REWARD_DURATION_MINUTES;

class RewadedManager {
  reward: RewardType = null;
  rewardedPopup: { type: RewardType; text: string; ammount?: number } | null = null;

  private nextShow: Date;

  private deactivateRewardTimeout: number | null = null;

  constructor() {
    makeAutoObservable(this);
    this.nextShow = addMinutes(new Date(), INITIAL_INTERVAL_MINUTES);
    window.setInterval(() => {
      this.tryShowPopup();
    }, 1000);
  }
  public tryShowPopup() {
    // reward already active or popup is displayed
    if (this.reward !== null || this.rewardedPopup !== null) {
      return;
    }
    // a popup is displayed
    if (DATA.openPopup !== null || DATA.planTripPopup !== null) {
      return;
    }
    if (new Date() < this.nextShow) {
      return;
    }

    const options = ['speed', 'price', 'money'];
    const reward = options[Math.floor(Math.random() * options.length)] as RewardType;
    switch (reward) {
      case 'speed':
        this.rewardedPopup = {
          text: `Double airplane speed for the next ${REWARD_DURATION_MINUTES} minutes`,
          type: 'speed',
        };
        break;
      case 'price':
        this.rewardedPopup = {
          text: `Double ticket price for the next ${REWARD_DURATION_MINUTES} minutes`,
          type: 'price',
        };
        break;
      case 'money':
        // give as much money as if the airplanes flew 20 times
        const totalAirplaneCapacity = DATA.airplanes.reduce((acc, airplane) => acc + airplane.getUpgradeValue('capacity'), 0);
        const averageTicketPrice =
          DATA.airplanes.reduce((acc, airplane) => acc + airplane.getUpgradeValue('ticket_price'), 0) / DATA.airplanes.length;
        const ammount = Math.floor(totalAirplaneCapacity * averageTicketPrice * 20);
        this.rewardedPopup = {
          text: `set in popup`,
          type: 'money',
          ammount,
        };
        break;
    }
  }

  public hidePopup() {
    let interval = this.rewardedPopup?.type !== 'money' ? SUBSEQUENT_INTERVAL_MINUTES : INITIAL_INTERVAL_MINUTES;
    this.nextShow = addMinutes(new Date(), interval);
    this.rewardedPopup = null;
  }

  public collectReward() {
    if (this.rewardedPopup?.type === 'money') {
      DATA.addMoney(this.rewardedPopup.ammount!);
    } else {
      this.reward = this.rewardedPopup?.type!;
      this.deactivateRewardTimeout = window.setTimeout(
        () => {
          this.endReward();
        },
        REWARD_DURATION_MINUTES * 60 * 1000,
      );
    }
    this.hidePopup();
  }

  public endReward() {
    if (this.deactivateRewardTimeout) {
      window.clearTimeout(this.deactivateRewardTimeout);
    }
    this.deactivateRewardTimeout = null;
    this.reward = null;
  }
}

export const REWARD = new RewadedManager();
